<script lang="ts">
  import Button from "$components/+design-system/Button/Button.svelte";

  export let logo: string;
  export let text: string;
  export let logoSize = "size-3";
</script>

<Button on:click label={text} variant="primary" size="large" isFullWidth>
  <svelte slot="left">
    <img src={logo} class={logoSize} alt={text + " logo"} />
  </svelte>
</Button>
